<template>
    <Modal @ok="confirm" @cancel="close" :show-footer="false" :show-title="false">
        <div class="create-plan-information">
            <div class="svg-banner">
                <Discount />
            </div>
            <div class="discount">{{ $t("message.annualPurchaseDiscount") }}</div>
            <div class="description" v-if="planPeriod == 'monthly'">
               {{ $t("message.packagePurchaseConfirmation") }}
            </div>
            <div class="description" v-else>
                {{ $t("message.packageConfirmationMessage") }}
            </div>

            <div class="footer">
                <div class="subbutton cancel" @click="close">{{ $t("billing.cancelIt") }}</div>
                <div class="subbutton" @click="confirm">{{ $t("billing.buyIt") }}</div>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import Discount from "../svg/Discount.vue";

export default {
    name: "CreatePlanModal",
    components: {
        Modal,
        Discount,
    },
    props: {
        planPeriod: {
            type: String,
            default: "monthly",
        },
    },
    methods: {
        close() {
            this.$emit("reject");
        },
        confirm() {
            this.$emit("confirm");
        },
    },
};
</script>
<style lang="scss">
.create-plan-information {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .discount {
        font-weight: bold;
        font-size: 18px;
    }
    .description {
        font-size: 16px;
        margin-top: 10px;
    }

    .subbutton {
        padding: 7px 20px;
        background: rgb(236, 75, 29);
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        color: white;
        margin-top: 25px;
        &:hover {
            background: rgb(252, 115, 77);
        }
    }
    .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px
    }
}
.svg-banner {
    width: 200px;
    height: 170px;
    svg {
        width: 100%;
        height: 100%;
    }
}
</style>
